import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const PageResearchNotificationsInitizializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={{}}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageResearchNotificationsInitizializer.displayName =
  'Page Research Notifications Initizializer component';

export default PageResearchNotificationsInitizializer;
